import moment from 'moment';
// -------------------------------------------------------
// ** in MAIN folder ** (improved version)
// -------------------------------------------------------

// incoming date should be YYYY-MM-DD  (ISO 8601 standard)
const getFormattedDate = (date) => {
	if (!date) return "";
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	];
	let cdate = new Date(date); // incoming date should be YYYY-MM-DD  (ISO 8601 standard)

	if (cdate == "Invalid Date") return "n/a";

	let formatted_date = `${cdate.getDate()} ${
		months[cdate.getMonth()]
		} ${cdate.getFullYear()}`;

	return formatted_date;
};

const getFormattedValue = (value) => {
	if (!value) return "£ 0";
	value = Number(value);

	return "£ " + (value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');  // 12,345.67
};

// returns the current date YYYY-MM-DD  (ISO 8601 standard)
const getCurrentDateISO8601 = (date = new Date()) => {
	console.log("getCurrentDateISO8601 - incoming date: " + date);
	let cdate = new Date().toISOString();
	if (date)
		cdate = date.toISOString();
	return cdate.substring(0, 10);	// safely take the first 10 chars representing the YYYY-MM-DD part
};

// returns in format: 2020-03-15T08:01:32.375Z
const getCurrentDateISO8601Full = () => {
	let cdate = new Date().toISOString();
	return cdate;
};

const getNiceDateTime = (date) => {
	let dateOnly = getFormattedDate(date);
	let timeOnly = moment(date).format("HH:mm:ss");
	return `${dateOnly} - ${timeOnly}`;
};

// const getFormattedHour = (hours) => {
// 	//return Number.parseInt(hours).toFixed(2);
// 	return hours.padStart(2, '0');
// };

export { getFormattedDate, getFormattedValue, getCurrentDateISO8601, getCurrentDateISO8601Full, getNiceDateTime };